// import SecureLS from 'secure-ls'
// var adminLoggingIn = new SecureLS({encodingType: 'aes'});
// adminLoggingIn.set('adminLoggingIn', {data: true});

export const initialStateGlobalSettings = () => ({
    /***
     * Constante para estado inicial de la store
     */
    // adminLoggingIn: false,
    logoutState: false,
    idleLogout: false,
    idleTime: 360000,
    resetToken: null,
    resetUserId: null,
    user: {}
})

export default initialStateGlobalSettings()